import { call, put, takeLatest } from "redux-saga/effects";

import {
  ADD_NEW_INTERVIEWER,
  GET_INTERVIEWERS_DATA,
  GET_SCHEDULER_INTERVIEW_DETAILS,
  POST_INTERVIEW_ROUND,
  REJECT_CANDIDATE,
  SCHEDULE_INTERVIEW,
  UPDATE_INTERVIEW_DETAILS,
  GET_INTERVIEW_ROUNDS,
  GET_INTERVIEW_RECORDINGS,
} from "./actionTypes";
import {
  addInterviewRoundFail,
  addInterviewRoundSuccess,
  addInterviewerFailed,
  addInterviewerSuccess,
  getInterviewerDataFalied,
  getInterviewerDataSuccess,
  getScheduleInterviewDetailsSuccess,
  rejectCandiateFailed,
  rejectCandiateSuccess,
  scheduleInterviewFail,
  scheduleInterviewSuccess,
  updateInterviewDetailsFalied,
  updateInterviewDetailsSuccess,
  getInterviewRoundsSuccess,
  getInterviewRoundsFailed,
  getInterviewRecordingsSuccess,
  getInterviewRecordingsFailure,
} from "./actions";

import { showErrorMessage } from "../../actions";

import { getCall, postCall } from "../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../common/constant/constantURL";

function* scheduleInterview({ payload: { json } }) {
  try {
    const url = constClass.REST_API_SCHEDULE_INTERVIEW;
    let responsJSON = yield call(postCall, url, json);

    // If backend is returning OAuth info in the success path (unlikely, but safe)
    if (responsJSON?.requiresAuth && responsJSON?.authUrl) {
      // Option A: popup
      window.open(
        responsJSON.authUrl,
        "googleOAuth",
        "width=500,height=600,scrollbars=yes",
      );
      // Optionally remember where we were:
      localStorage.setItem(
        "oauthReturnUrl",
        window.location.pathname + window.location.search,
      );
      return;
    }

    yield put(scheduleInterviewSuccess(responsJSON.message));
  } catch (error) {
    // If error from postCall is the OAuth hint object:
    if (error?.requiresAuth && error?.authUrl) {
      // Save current location so OauthCallback can return here
      localStorage.setItem(
        "oauthReturnUrl",
        window.location.pathname + window.location.search,
      );

      // You can choose popup or redirect. Popup is nicer:
      window.open(
        error.authUrl,
        "googleOAuth",
        "width=500,height=600,scrollbars=yes",
      );

      // Or full redirect:
      // window.location.href = error.authUrl;

      return;
    }

    const errormessage = error?.response?.data
      ? typeof error.response.data === "string"
        ? JSON.parse(error.response.data).errormessage
        : error.response.data.errormessage
      : error.message || "Update failed";

    yield put(scheduleInterviewFail(errormessage));
  }
}

function* getSchedulerInterviewDetails({ payload: { jobId, candidateId } }) {
  try {
    if (
      jobId === undefined ||
      jobId === null ||
      jobId === "" ||
      jobId === "null" ||
      candidateId === undefined ||
      candidateId === null ||
      candidateId === "" ||
      candidateId === "null"
    ) {
      return;
    }

    const url =
      constClass.REST_API_GET_SCHEDULE_INTERVIEWS +
      `?jobId=${encodeURIComponent(jobId)}&candidateId=${encodeURIComponent(candidateId)}`;

    const responsJSON = yield call(getCall, url);
    yield put(getScheduleInterviewDetailsSuccess(responsJSON));
  } catch (error) {
    yield put(showErrorMessage(error));
  }
}

function* getInterviewerListFunc({ payload: { jobId, allList } }) {
  try {
    let url = constClass.REST_API_GET_INTERVIEWERS;
    //to show specific  interviewer list to  recruiter user
    if (jobId !== undefined && jobId !== null && jobId !== "") {
      url = `${url}?jobId=${jobId}`;
    }
    //to show all interviewer list to  recruiter user
    if (allList !== undefined && allList !== null && allList !== "") {
      url = `${url}?allList=${allList}`;
    }
    let responsJSON = yield call(getCall, url);
    yield put(getInterviewerDataSuccess(responsJSON));
  } catch (error) {
    yield put(getInterviewerDataFalied(error));
  }
}
function* addInterviewRounds({ payload: { json } }) {
  try {
    const url = constClass.REST_API_POST_ADD_INTERVIEW_ROUND;
    let responsJSON = yield call(postCall, url, json);
    yield put(addInterviewRoundSuccess(responsJSON.message));
    // console.log("saga", responsJSON)
  } catch (error) {
    yield put(addInterviewRoundFail(error));
  }
}

function* updateInterviewDetails({ payload: json }) {
  try {
    const url = constClass.REST_API_SCHEDULE_INTERVIEW_UPDATE;
    let responsJSON = yield call(postCall, url, json);

    if (responsJSON?.requiresAuth === true && responsJSON?.authUrl) {
      window.open(
        responsJSON.authUrl,
        "googleOAuth",
        "width=500,height=600,scrollbars=yes",
      );
      return;
    }

    yield put(updateInterviewDetailsSuccess(responsJSON.message));
  } catch (error) {
    if (error.requiresAuth && error.authUrl) {
      // Save current page so we can return after OAuth
      localStorage.setItem(
        "oauthReturnUrl",
        window.location.pathname + window.location.search,
      );
      window.location.href = error.authUrl;
      return;
    }

    const errormessage =
      error?.response?.data?.errormessage || error?.message || "Update failed";

    yield put(scheduleInterviewFail(errormessage));
    yield put(updateInterviewDetailsFalied(errormessage));
  }
}

function* rejectCandidate({ payload: { data } }) {
  try {
    const url = constClass.REST_API_REJECT_CANDIDATE;
    let responsJSON = yield call(postCall, url, data);
    yield put(rejectCandiateSuccess(responsJSON));
  } catch (error) {
    yield put(rejectCandiateFailed(error));
  }
}

function* addInterviewerHandler(dat) {
  try {
    let data = dat.payload;
    let url = constClass.REST_API_INTERVIEWERS;
    yield call(postCall, url, data);
    yield put(
      addInterviewerSuccess("Interviewer has been added successfully."),
    );
  } catch (error) {
    yield put(addInterviewerFailed(error));
  }
}

function* fetchInterviewRounds({ payload: { jobId } }) {
  try {
    const url = `${constClass.REST_API_GET_INTERVIEW_ROUNDS}?jobId=${jobId}`;
    const response = yield call(getCall, url);
    yield put(getInterviewRoundsSuccess(response));
  } catch (error) {
    yield put(getInterviewRoundsFailed(error));
  }
}

function* fetchInterviewRecordings({ payload: { interviewId } }) {
  try {
    const url = `${constClass.REST_API_GET_INTERVIEW_RECORDINGS}/${interviewId}/recordings`;

    const response = yield call(getCall, url);

    yield put(getInterviewRecordingsSuccess(interviewId, response));
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.errormessage ||
      error?.message ||
      "Failed to fetch interview recordings";

    yield put(getInterviewRecordingsFailure(interviewId, errorMessage));
  }
}

function* interviewSaga() {
  yield takeLatest(
    GET_SCHEDULER_INTERVIEW_DETAILS,
    getSchedulerInterviewDetails,
  );
  yield takeLatest(GET_INTERVIEWERS_DATA, getInterviewerListFunc);
  yield takeLatest(POST_INTERVIEW_ROUND, addInterviewRounds);
  yield takeLatest(SCHEDULE_INTERVIEW, scheduleInterview);
  yield takeLatest(UPDATE_INTERVIEW_DETAILS, updateInterviewDetails);
  yield takeLatest(REJECT_CANDIDATE, rejectCandidate);
  yield takeLatest(ADD_NEW_INTERVIEWER, addInterviewerHandler);
  yield takeLatest(GET_INTERVIEW_ROUNDS, fetchInterviewRounds);
  yield takeLatest(GET_INTERVIEW_RECORDINGS, fetchInterviewRecordings);
}

export default interviewSaga;
